import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { subscriptionAdminApi } from '../subscriptionAdmin/api';
import { canAccessSubscriptionAdmin, setSession, getSession } from '../utils/sessionStore';

export const SubscriptionAdminRoute = ({ element }) => {
  const [state, setState] = useState(() =>
    canAccessSubscriptionAdmin() ? 'loading' : 'denied'
  );

  useEffect(() => {
    let cancelled = false;

    async function verify() {
      if (!canAccessSubscriptionAdmin()) {
        if (!cancelled) setState('denied');
        return;
      }
      setState('loading');
      try {
        const authInfo = await subscriptionAdminApi.authInfo();
        if (cancelled) return;
        if (authInfo) {
          setSession({ ...getSession(), subscriptionAdmin: authInfo });
          setState('allowed');
        } else {
          setState('denied');
        }
      } catch {
        if (!cancelled) setState('denied');
      }
    }

    verify();
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === 'loading') {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (state === 'allowed') {
    return element;
  }

  return <Navigate to="/admin-dashboard" replace state={{ accessDenied: true }} />;
};
